import { useCallback, useState } from "react";
import { downloadFile } from "@/utils/downloadFile";
import { toIsoDate } from "../utils/defaultDateRange";

interface UseDownloadMemberReportCsvOptions<TParams> {
  fetchCsv: (params: TParams) => Promise<Blob>;
  /** File name stem; the download is `{prefix}-{YYYY-MM-DD}.csv`. */
  fileNamePrefix: string;
}

export function useDownloadMemberReportCsv<TParams>({
  fetchCsv,
  fileNamePrefix,
}: UseDownloadMemberReportCsvOptions<TParams>) {
  const [loading, setLoading] = useState(false);

  const downloadCsv = useCallback(
    (params: TParams) => {
      setLoading(true);
      const date = toIsoDate(new Date());
      return fetchCsv(params)
        .then((blob) => downloadFile(blob, `${fileNamePrefix}-${date}.csv`))
        .catch(() => undefined)
        .finally(() => setLoading(false));
    },
    [fetchCsv, fileNamePrefix],
  );

  return { loading, downloadCsv };
}
